module.exports = __webpack_public_path__ + "media/images/photo/footer-logo-2d9290a07f346140414eaae1a55851b9.png";